import { Crown, Heart, Star, Swords } from 'lucide-react';

/**
 * LeaderboardRow — single row in the global leaderboard.
 */
export default function LeaderboardRow({ rank, leader, canFollow, onFollow }) {
  const isTop3 = rank <= 2;
  const rankColor = rank === 0
    ? 'text-yellow-400'
    : rank === 1
      ? 'text-zinc-300'
      : rank === 2
        ? 'text-orange-400'
        : 'text-zinc-500';

  return (
    <div className={`flex items-center gap-4 p-4 border-b border-white/5 last:border-0 hover:bg-white/5 transition-colors ${rank === 0 ? 'bg-gradient-to-r from-yellow-500/10 to-transparent' : ''}`} data-testid={`leaderboard-row-${leader.id}`}>
      <div className={`w-10 text-center font-black text-lg ${rankColor}`}>
        {rank === 0 ? <Crown size={22} className="mx-auto" /> : `#${rank + 1}`}
      </div>
      <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-pink-500 to-purple-600 flex items-center justify-center text-2xl">{leader.avatar}</div>
      <div className="flex-1">
        <div className="font-bold text-white">{leader.username}</div>
        <div className="text-xs text-zinc-400 flex items-center gap-3">
          <span className="flex items-center gap-1"><Heart size={10} className="text-pink-400" />{leader.fans.toLocaleString()}</span>
          <span className="flex items-center gap-1"><Star size={10} className="text-yellow-400" /> Niv. {leader.level}</span>
          <span className="flex items-center gap-1"><Swords size={10} className="text-purple-400" />{leader.battles_won} W</span>
        </div>
      </div>
      {canFollow && (
        <button onClick={() => onFollow(leader.id)} className="glass-light rounded-xl px-3 py-1.5 text-xs font-semibold text-pink-300 hover:bg-pink-500/20 transition-colors" data-testid={`follow-btn-${leader.id}`}>
          Suivre
        </button>
      )}
      {/* Marker for isTop3 — used elsewhere in tests if needed */}
      {isTop3 && <span className="sr-only">top3</span>}
    </div>
  );
}
